var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1000003613(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3378 11.4922H34.5061C37.2676 11.4922 39.5061 13.7308 39.5061 16.4922V29.2439C39.5061 32.0053 37.2676 34.2439 34.5061 34.2439H9.50781C6.74639 34.2439 4.50781 32.0053 4.50781 29.2439V16.4922C4.50781 13.7308 6.74639 11.4922 9.50781 11.4922H11.6578",
    stroke: "#673ee5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41.2533V34.25",
    stroke: "#673ee5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7478 41.25H13.2578",
    stroke: "#673ee5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9972 23.76C27.7989 23.76 32.5022 19.0568 32.5022 13.255C32.5022 7.45325 27.7989 2.75 21.9972 2.75C16.1954 2.75 11.4922 7.45325 11.4922 13.255C11.4922 19.0568 16.1954 23.76 21.9972 23.76Z",
    stroke: "#673ee5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4922 13.2578H32.5022",
    stroke: "#673ee5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0017 23.76C23.9356 23.76 25.5033 19.0568 25.5033 13.255C25.5033 7.45325 23.9356 2.75 22.0017 2.75C20.0677 2.75 18.5 7.45325 18.5 13.255C18.5 19.0568 20.0677 23.76 22.0017 23.76Z",
    stroke: "#673ee5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000003613);
export default __webpack_public_path__ + "static/media/Group 1000003613.67fb149cecc23fd3e5dc566dc4cac222.svg";
export { ForwardRef as ReactComponent };